import { RitzAPI, } from '@moderepo/mode-internal-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var MetricsReportSubscriptionsActionType;
(function (MetricsReportSubscriptionsActionType) {
    MetricsReportSubscriptionsActionType["SET_SUBSCRIPTIONS"] = "set multiple subscriptions";
    MetricsReportSubscriptionsActionType["SET_SUBSCRIPTION"] = "set 1 subscription";
    MetricsReportSubscriptionsActionType["CLEAR_SUBSCRIPTIONS"] = "clear subscriptions";
})(MetricsReportSubscriptionsActionType || (MetricsReportSubscriptionsActionType = {}));
/**
 * Create an action to set a list of subscriptions
 */
export const setMetricsReportSubscriptions = (subscriptions, searchParams) => {
    return {
        type: MetricsReportSubscriptionsActionType.SET_SUBSCRIPTIONS,
        subscriptions,
        searchParams,
    };
};
/**
 * Create an action to set 1 subscription
 */
export const setMetricsReportSubscription = (subscription) => {
    return {
        type: MetricsReportSubscriptionsActionType.SET_SUBSCRIPTION,
        subscription,
    };
};
/**
 * Create an action to clear all subscriptions
 */
export const clearMetricsReportSubscriptions = () => {
    return {
        type: MetricsReportSubscriptionsActionType.CLEAR_SUBSCRIPTIONS,
    };
};
/**
 * Create a metrics report subscription
 */
export const createMetricsReportSubscription = (params) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().createMetricsReportSubscription(params);
        // Because we added 1 subscription, the pagination no longer valid therefore we need to clear the subscriptions
        await dataDispatch(clearMetricsReportSubscriptions());
    };
};
/**
 * Get all metrics report subscriptions filtered by the provided filters
 */
export const fetchMetricsReportSubscriptions = (filters) => {
    return async (dataDispatch) => {
        const modifiedFilters = {
            // Copy the filters
            ...filters,
            // change pageSize/pageNumber to skip/limit
            skip: filters.pageNumber !== undefined && filters.pageSize !== undefined ? filters.pageNumber * filters.pageSize : undefined,
            limit: filters.pageSize !== undefined ? filters.pageSize : undefined,
            // exclude pageSize/pageNumber
            pageNumber: undefined,
            pageSize: undefined,
        };
        const subscriptions = await RitzAPI.getInstance().getMetricsReportSubscriptions(modifiedFilters);
        await dataDispatch(setMetricsReportSubscriptions(subscriptions, searchParamsToString(filters)));
    };
};
/**
 * Get 1 metrics report subscription
 */
export const fetchMetricsReportSubscriptionById = (subscriptionId) => {
    return async (dataDispatch) => {
        const subscription = await RitzAPI.getInstance().getMetricsReportSubscriptionById(subscriptionId);
        await dataDispatch(setMetricsReportSubscription(subscription));
    };
};
/**
 * Delete a subscription from a project.
 * @param subscriptionId - The id of the subscription we want to delete
 */
export const deleteMetricsReportSubscription = (subscriptionId) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().deleteMetricsReportSubscription(subscriptionId);
        // Because we deleted 1 subscription, the pagination no longer valid therefore we need to clear the subscriptions
        await dataDispatch(clearMetricsReportSubscriptions());
    };
};
/**
 * Update a subscription. id of the project the devices belonged to
 */
export const updateMetricsReportSubscription = (subscriptionId, params) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().updateMetricsReportSubscription(subscriptionId, params);
        await dataDispatch(fetchMetricsReportSubscriptionById(subscriptionId));
    };
};
